import { render } from "./ClientProfile.vue?vue&type=template&id=c80642a2"
import script from "./ClientProfile.vue?vue&type=script&lang=js"
export * from "./ClientProfile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__